var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 108,
    viewBox: "0 0 159 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3774 50.0625C1.3774 22.8007 23.4775 0.700643 50.7393 0.700643H108.739C136.001 0.700643 158.101 22.8007 158.101 50.0625V106.424H50.7393C23.4775 106.424 1.3774 84.3243 1.3774 57.0625V50.0625Z",
    fill: "#0047AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4056 58.8965H85.0723V53.5632H74.4056V58.8965ZM74.4056 50.8965H95.7389V45.5632H74.4056V50.8965ZM74.4056 42.8965H95.7389V37.5632H74.4056V42.8965ZM69.0723 69.5632C67.6056 69.5632 66.3505 69.0414 65.3069 67.9978C64.2616 66.9525 63.7389 65.6965 63.7389 64.2298V32.2298C63.7389 30.7632 64.2616 29.5072 65.3069 28.4618C66.3505 27.4183 67.6056 26.8965 69.0723 26.8965H101.072C102.539 26.8965 103.795 27.4183 104.84 28.4618C105.884 29.5072 106.406 30.7632 106.406 32.2298V64.2298C106.406 65.6965 105.884 66.9525 104.84 67.9978C103.795 69.0414 102.539 69.5632 101.072 69.5632H69.0723ZM58.4056 80.2298C56.9389 80.2298 55.6838 79.708 54.6403 78.6645C53.5949 77.6192 53.0723 76.3632 53.0723 74.8965V37.5632H58.4056V74.8965H95.7389V80.2298H58.4056Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3774 50.0625C1.3774 22.8007 23.4775 0.700643 50.7393 0.700643H108.739C136.001 0.700643 158.101 22.8007 158.101 50.0625V106.424H50.7393C23.4775 106.424 1.3774 84.3243 1.3774 57.0625V50.0625Z",
    stroke: "#0047AF",
    strokeWidth: 1.27629
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.e923e42cbb73bdc2313917f5d4953dbe.svg";
export { ForwardRef as ReactComponent };